import { Injectable } from '@angular/core';

import { DialogService } from './dialog.service';
import { DialogResultType } from '../model/dialog-result-type';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesDialogService {
  private isConfirming = false;

  constructor(private dialogService: DialogService) {}

  confirm(): Promise<boolean> {
    if (this.isConfirming) {
      // A second CanDeactivate fired while the dialog is already open (e.g., the user pressed
      // browser back a second time). Block the second navigation so the first dialog remains
      // in control — the user will answer it and the correct navigation will follow.
      //
      // Why not return true (treat as "Yes, leave")?
      // By the time this second guard fires, the browser history pointer has already moved two
      // steps back (e.g., to ManageAccount). Returning true would confirm *that* navigation,
      // landing the user on the wrong page. Doing it correctly would require tracking the first
      // navigation's intended destination and redirecting there manually — not worth the
      // complexity. Returning false lets Angular (canceledNavigationResolution: 'computed')
      // restore the URL, and the still-open dialog gives the user a clean path forward.
      return Promise.resolve(false);
    }

    this.isConfirming = true;

    return this.dialogService
      .confirmDialog(
        $localize`:@@common.unsavedChangesDialog.title:Confirm`,
        $localize`:@@common.unsavedChangesDialog.message:You have unsaved changes. Do you want to discard these changes?`
      )
      .then(result => result === DialogResultType.Yes)
      .finally(() => {
        this.isConfirming = false;
      });
  }
}
